module.exports = __webpack_public_path__ + "img/live1.fcd28afd.png";